import { Controller } from "@hotwired/stimulus"

// Renders the value input(s) for a column filter based on the selected operator
// and the column's data kind. Shared by the data-rows filter modals (data tables
// & custom queries) and the story-channels large-grid column filter modal.
//
//   • blank / notBlank (and is_null/is_empty/is_not_empty) → no value input
//   • between / inRange / bt                               → two inputs (From/To)
//   • everything else                                      → one input
//
// Input type follows the column kind: date → datepicker, number → numeric, else text.
export default class extends Controller {
  static targets = ["operator", "valueInputs"]
  static values = {
    index: Number,
    kind: { type: String, default: "String" },
    values: { type: Array, default: [] }
  }

  connect() {
    this.render(this.valuesValue || [])
  }

  updateOperator() {
    this.render([])
  }

  render(initial) {
    if (!this.hasValueInputsTarget) return
    const op = this.hasOperatorTarget ? this.operatorTarget.value : "eq"
    const idx = this.indexValue
    const kind = this.kindValue || "String"
    const isDate = /Date/.test(kind)
    const isNumber = /Number|Float|Integer|Decimal|Double/.test(kind)
    const container = this.valueInputsTarget

    // Preserve already-typed values across operator changes.
    const prev = (initial && initial.length)
      ? initial.slice()
      : Array.from(container.querySelectorAll("input")).map(i => i.value)

    container.innerHTML = ""

    if (["blank", "notBlank", "is_null", "is_empty", "is_not_empty"].includes(op)) return

    const range = (op === "between" || op === "inRange" || op === "bt")

    const make = (placeholder, name, val) => {
      const wrap = document.createElement("div")
      wrap.className = "mb-2"
      const input = document.createElement("input")
      input.className = "w-full h-ctl px-2 border border-hair-hi rounded-ctl bg-surface text-ui text-ink placeholder-ink-faint focus:outline-none focus:border-brand focus:ring-4 focus:ring-brand-soft"
      input.placeholder = placeholder
      input.name = name
      if (val != null && val !== "") input.value = val
      if (isDate) {
        input.type = "text"
        input.setAttribute("data-controller", "datepicker")
      } else if (isNumber) {
        input.type = "number"
        input.step = "any"
      } else {
        input.type = "text"
      }
      wrap.appendChild(input)
      container.appendChild(wrap)
    }

    if (range) {
      make(isDate ? "Start Date" : "From", `filters[${idx}][value][]`, prev[0])
      make(isDate ? "End Date" : "To", `filters[${idx}][value][]`, prev[1])
    } else {
      make(isDate ? "Select Date" : "Value", `filters[${idx}][value]`, prev[0])
    }
  }
}
